"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsIntlManager = void 0;
var _reactIntlUniversal = require("react-intl-universal");
var _Locales = require("../../constants/Locales");
var _DmsTokenHook = require("../../components/DmsTokenHook/DmsTokenHook");
var _DmsFetch = require("../../components/DmsFetch/DmsFetch");
const DmsIntlManager = exports.DmsIntlManager = {
  init: async function () {
    let language = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'en-US';
    await (0, _reactIntlUniversal.init)({
      currentLocale: language,
      locales: _Locales.LOCALES
    });
  },
  updateLanguage: async (language, setLanguage) => {
    const currentData = await DmsIntlManager.getCurrent();
    if (currentData && language && language !== currentData.currentLocale) {
      setLanguage(language);
      await DmsIntlManager.init(language);
    }
  },
  additionalLocales: locale => {
    (0, _reactIntlUniversal.load)(locale);
  },
  getCurrent: () => (0, _reactIntlUniversal.getInitOptions)(),
  getLanguage: async () => {
    const fetchSystemLanguage = async () => {
      var _response$data;
      const response = await (0, _DmsFetch.fetchData)('system_settings/language', 'GET', false);
      return ((_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.data) || navigator.language;
    };
    const fetchUserLanguage = async () => {
      const token = (0, _DmsTokenHook.getToken)();
      if (token !== null && token !== void 0 && token.login) {
        var _response$data2;
        const response = await (0, _DmsFetch.fetchData)("/user/language/".concat(token.login), 'GET', true);
        return ((_response$data2 = response.data) === null || _response$data2 === void 0 || (_response$data2 = _response$data2.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.user_language) || null;
      }
      return null;
    };
    const userLanguage = await fetchUserLanguage();
    return userLanguage || (await fetchSystemLanguage());
  }
};